import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Alert, Box, Button, Grid, Link, Paper, Stack, Typography } from "@mui/material";
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import ConfirmPhone from "../ConfirmPhone";
import palette from "../../theme/palette";
import { resendconfmail } from "../Common/functions"
export default function TunnelTerminaison({ state, setState, app }) {

	return (
		<div>
			{(state.email_checked &&
				state.phone1_checked) && <Paper
					//	style="margin-bottom: 40px; width: 100%;" 

					style={{ marginBottom: "40px", backgroundColor: palette.greenAlert }}>
					<Box
						display="flex"
						alignItems="flex-start"
						justifyContent="center"
						p={1}
						flexDirection="column"
					>
						<Box p={1} style="margin-bottom: 10px">
							<Typography variant="h5">Félicitations !</Typography>
						</Box>
						<Box p={1} >
							Bienvenue sur Bkeys.
						</Box>
					</Box>
				</Paper>}
			{(!state.email_checked ||
				!state.phone1_checked) && <Alert
					//	style="margin-bottom: 40px; width: 100%;" 
					severity={"warning"}
					action={false}
					style="margin: 0px 10px 10px; box-shadow: 0px 0px 5px 0px red;"
				>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="center"
						p={1}
						flexDirection="column"
					>
						<Box p={1} style="">
							<Typography variant="h5" style="margin-bottom: 10px;">L'utilisation du site Bkeys nécessite la validation de votre adresse email et de votre numéro de téléphone.</Typography>
							<Typography variant="h5"><u>Merci d'effectuer {!state.email_checked && !state.phone1_checked ? "les 2 actions suivantes" : "l'action suivante"} :</u></Typography>
						</Box>
						{/* <Box p={1} >

						<Typography variant="body1">
							Prenez le temps de confirmer {!state.email_checked && "votre adresse email"}
							{!state.email_checked && !state.phone1_checked && <span> et</span>}
							{!state.phone1_checked && " votre numéro de téléphone"}
							&nbsp;avant de pouvoir accéder au site
						</Typography>

					</Box> */}
					</Box>
				</Alert>}
			<Stack style="margin-top: 20px;" >
				{!state.email_checked && (
					<Box display={"flex"} justifyContent="flex-start" alignItems={"flex-start"}>
						<Box p={1}>
							{/* {state.phone1_checked ? <LooksOneIcon color="primary" sx={{ fontSize: 40 }} /> : <LooksTwoIcon color="primary" sx={{ fontSize: 40 }} />} */}
							<LooksOneIcon color="primary" sx={{ fontSize: 40 }} />
						</Box>
						<Box p={1}>

							<Typography variant="h5">
								<u><b><span >Validez votre email.</span></b></u></Typography>
							<Typography variant="body1">
								Cliquez sur le lien de confirmation de l'email que vous avez reçu. Pensez à vérifier vos spams.
							</Typography>
							<Stack spacing={2}>

								{/* <Button onClick={resendconfmail} size="small">Renvoyer un email de confirmation</Button> */}
								<Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} style="margin-bottom: 20px;margin-top: 10px;">

									<Box>
										<Typography variant="body1" paragraph={false}>(Vous n'avez pas reçu d'email de confirmation ?</Typography>
									</Box>

									<Box >

										{/* <Button onClick={resendconfmail} size="small">Renvoyer un email de confirmation</Button> */}
										<Link href="#" onClick={() => resendconfmail(app)} underline="none" style="margin-left: 10px">
											On peut vous renvoyer un email de confirmation
										</Link>)
									</Box>


								</Box>

							</Stack>



						</Box >
					</Box >

				)
				}
				{
					!state.phone1_checked && (
						<Stack>
							<Box display={"flex"} justifyContent="flex-start" alignItems={"flex-start"}>
								<Box p={1}>
									{state.email_checked ? <LooksOneIcon color="primary" sx={{ fontSize: 40 }} /> : <LooksTwoIcon color="primary" sx={{ fontSize: 40 }} />}
								</Box>
								<Box p={1}>

									<Box>
										<Stack>
											<Typography variant="h5" style="margin-bottom: 10px;">
												<u><b><span >Vérifiez votre numéro de téléphone</span></b></u></Typography>
											<Typography variant="body1">Renseignez le code que vous venez de recevoir sur votre mobile</Typography>
											<ConfirmPhone setUpperState={setState} />
										</Stack>
									</Box>

								</Box>
							</Box>

						</Stack>


					)
				}
			</Stack >



		</div >
	);
}
